// ignore-string-externalization
import styled, { css } from 'styled-components';
import { Link } from '../ui';
import { screenMdMin, spacer32 } from '@spotify-internal/encore-web';
export var isHelpLive = true;
export var HELP_LIST_TRACK_CAT = 'Help List';
export var categoryTrackLabel = function categoryTrackLabel(category) {
  return "Category - ".concat((category === null || category === void 0 ? void 0 : category.name) || 'Unknown');
};
export var articleTrackLabel = function articleTrackLabel(article) {
  return "Article - ".concat(article.question);
};
var baseUrl = '/help';
export var categoryUrl = function categoryUrl(category) {
  return "".concat(baseUrl).concat(category ? "/".concat(category.urlSlug) : '');
};
export var articleUrl = function articleUrl(article, category) {
  return "".concat(baseUrl, "/article/").concat(article.urlSlug).concat(category ? "?category=".concat(category.urlSlug) : '');
};
export var LinkWithHelpHighlight = styled(Link).withConfig({
  displayName: "util__LinkWithHelpHighlight",
  componentId: "sc-1i0nuuc-0"
})(["&:hover,&:focus:not(:disabled),&:active:not(:disabled),&.highlight{color:", ";}&:focus:not(:hover),&:active:not(:hover),&.highlight:not(:hover){color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.help.link.hover;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
});
export var ChevronLink = styled(Link).withConfig({
  displayName: "util__ChevronLink",
  componentId: "sc-1i0nuuc-1"
})(["&:hover,&:focus:not(:disabled),&:active:not(:disabled),&.highlight{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.box.text;
});
export var hidden = css(["visibility:hidden;height:0;padding:0;margin:0;"]);
export var border = css(["border-bottom:1px solid ", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.help.link.divider;
});
export var SearchBarContainer = styled.div.withConfig({
  displayName: "util__SearchBarContainer",
  componentId: "sc-1i0nuuc-2"
})(["margin-bottom:", ";@media (min-width:", "){", "}"], spacer32, screenMdMin, hidden);